import { redisGetHandler } from "../utils/redis";
import { draftQueryParam } from "./draft";

/** Единый тип статических страниц: домен хранится в data.domain записи */
const PAGES_STATIC_TYPE = "content-pages-static";

/** Все записи типа; с code — только записи этого url (по одной на домен) */
async function fetchAllByType(
  axios,
  config,
  Redis,
  type,
  reset = false,
  code = "",
) {
  const baseUrl = config.SERVICE_DATABASE_API_URL || config.API_URL;
  const codeParam = code ? `&code=${encodeURIComponent(code)}` : "";
  const path = `/content/getAll?type=${type}${codeParam}${draftQueryParam(config)}`;
  const data = await redisGetHandler(Redis, axios, baseUrl, path, reset);
  return Array.isArray(data) ? data : [];
}

/** Одна запись по типу и коду — чтобы не тянуть весь список в память */
async function fetchByTypeAndCode(
  axios,
  config,
  Redis,
  type,
  code,
  reset = false,
) {
  const baseUrl = config.SERVICE_DATABASE_API_URL || config.API_URL;
  const path = `/content/?type=${encodeURIComponent(type)}&code=${encodeURIComponent(code)}${draftQueryParam(config)}`;
  const data = await redisGetHandler(Redis, axios, baseUrl, path, reset);
  return data && typeof data === "object" && data.id ? data : null;
}

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getAllByType(Redis = false, reset = false, type) {
    return fetchAllByType(axios, config, Redis, type, reset);
  },
  // Где вызывается: сервер.
  async getDomains(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "domains", reset);
  },
  // Где вызывается: сервер.
  // Записи статической страницы по url: все страницы лежат в одном типе,
  // домен — обычное свойство записи, поэтому на один url приходится
  // до нескольких записей (своя на домен и общая root). Какая подходит —
  // решает вызывающий код (utils/pagesStaticDomain).
  async getMeta(Redis = false, reset = false, code = "") {
    if (!code) return [];
    return fetchAllByType(
      axios,
      config,
      Redis,
      PAGES_STATIC_TYPE,
      reset,
      code,
    );
  },
  // Где вызывается: сервер. Все статические страницы всех доменов.
  async getStaticPages(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, PAGES_STATIC_TYPE, reset);
  },
  // Где вызывается: сервер.
  async getShops(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "shops", reset);
  },
  // Где вызывается: сервер.
  async getShopsPages(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "content-pages-shops", reset);
  },
  // Где вызывается: сервер.
  async getContacts(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "contacts", reset);
  },
  // Где вызывается: сервер.
  async getBrands(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "brands", reset);
  },
  // Где вызывается: сервер.
  async getCertificates(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "certificates", reset);
  },
  // Где вызывается: сервер.
  async getUniversalPhotos(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "universal-photos", reset);
  },
  // Где вызывается: сервер.
  async getSeoStubs(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "seoStubs", reset);
  },
  // Где вызывается: сервер. Мета каталога (новый функционал панели, ?isNewMeta).
  async getSeoMetaCatalog(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "seo-meta-catalog", reset);
  },
  // Где вызывается: сервер. Мета товаров по разделам (панель, ?isNewMeta).
  async getSeoMetaProduct(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "seo-meta-product", reset);
  },
  /**
   * Где вызывается: сервер. Названия марки/модели по коду (`audi`, `audi:a4`).
   * Новый раздел панели «SEO → Каталог new → Названия марок/моделей».
   */
  async getSeoMarkName(Redis = false, reset = false, code = "") {
    if (!code) return null;
    return fetchByTypeAndCode(
      axios,
      config,
      Redis,
      "seo-mark-names",
      code,
      reset,
    );
  },
  /**
   * Где вызывается: сервер. СЕО текст значения фильтра по коду
   * (`tip_kryuka:nesemnyy`). Раздел «SEO → Каталог new → Названия фильтров».
   */
  async getSeoFilterName(Redis = false, reset = false, code = "") {
    if (!code) return null;
    return fetchByTypeAndCode(
      axios,
      config,
      Redis,
      "seo-filter-names",
      code,
      reset,
    );
  },
  // Где вызывается: не используется.
  async getMainBanner(Redis = false, reset = false) {
    return fetchAllByType(axios, config, Redis, "content-main-banner", reset);
  },
  async getProductDescriptions(Redis = false, reset = false) {
    return fetchAllByType(
      axios,
      config,
      Redis,
      "seo-product-descriptions",
      reset,
    );
  },
});
